// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"918":"66b02f19","1097":"66b02f19","1205":"66b02f19","3416":"66b02f19","4638":"66b02f19","7156":"66b02f19","7317":"66b02f19","8650":"d528f1ff","8754":"66b02f19"}[chunkId] + ".chunk.css";
};